import { render } from "./Help.vue?vue&type=template&id=74443e03&ts=true"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__